// extracted by mini-css-extract-plugin
export default {"wrap":"UE-z","subtitle":"VE-z","contentWrap":"WE-z","imgWrap":"XE-z","heading":"YE-z","copy":"ZE-z"};